export interface ModuleConfig {
  key: string;
  label: string;
  icon: string;
  path: string;
  group?: string;
  core?: boolean;
  permission?: string;
  permissions?: string[];
  role?: string;
  roles?: string[];
}

export const GROUP_META: Record<string, { label: string; icon: string }> = {
  "user-management": {
    label: "Gestion Utilisateurs",
    icon: "UsersRound",
  },
  "security": {
    label: "Sécurité & Clés de Service",
    icon: "ShieldAlert",
  },
  "support": {
    label: "Support Client",
    icon: "LifeBuoy",
  },
};

export const modulesConfig: ModuleConfig[] = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: "LayoutDashboard",
    path: "/",
    core: true,
    permission: "analytics.view",
  },
  {
    key: "audit-logs",
    label: "Audit Logs & Traçabilité",
    icon: "Activity",
    path: "/audit-logs",
    core: true,
    roles: ["developer", "admin", "owner", "superadmin"],
  },
  // User Management
  {
    key: "users",
    label: "Utilisateurs",
    icon: "Users",
    path: "/users",
    group: "user-management",
    permission: "users.view",
  },
  {
    key: "invitations",
    label: "Invitations",
    icon: "MailPlus",
    path: "/invitations",
    group: "user-management",
    permission: "invitations.view",
  },
  {
    key: "notifications",
    label: "Notifications Broadcast",
    icon: "Bell",
    path: "/notifications",
    group: "user-management",
    roles: ["developer", "admin", "owner"],
  },
  // Security & Service Keys
  {
    key: "roles",
    label: "Rôles",
    icon: "Shield",
    path: "/roles",
    group: "security",
    permission: "roles.view",
  },
  {
    key: "permissions",
    label: "Permissions",
    icon: "Key",
    path: "/permissions",
    group: "security",
    permission: "roles.view",
  },
  {
    key: "passkeys",
    label: "Passkeys",
    icon: "KeyRound",
    path: "/passkeys",
    group: "security",
    permission: "passkeys.view",
  },
  {
    key: "service-keys",
    label: "Service Keys (API)",
    icon: "Key",
    path: "/service-keys",
    group: "security",
    permission: "service_keys.view",
  },
  {
    key: "discord-tracker",
    label: "Service Keys (Discord Tokens)",
    icon: "Radio",
    path: "/discord",
    group: "security",
    permission: "discord.view",
  },
  // Support
  {
    key: "support-tickets",
    label: "Tickets & Live Chat",
    icon: "MessageSquare",
    path: "/support",
    group: "support",
  },
];
